var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_133_3350)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C6.68629 0 4 2.68629 4 6V36C4 39.3137 6.68629 42 10 42H40C43.3137 42 46 39.3137 46 36V23.987C45.9074 23.9956 45.8136 24 45.7188 24C44.0619 24 42.7188 22.6569 42.7188 21C42.7188 19.3431 44.0619 18 45.7188 18C45.8136 18 45.9074 18.0044 46 18.013V6C46 2.68629 43.3137 0 40 0H10Z",
    fill: "#04B7B1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0069 29.1472C33.1202 29.1481 32.2702 29.501 31.6439 30.1282C31.0173 30.7555 30.6656 31.6059 30.666 32.4923C30.6662 33.3789 31.0185 34.2289 31.6455 34.8559C32.2723 35.4827 33.1225 35.8349 34.0089 35.8354C34.8955 35.8356 35.7457 35.4838 36.3729 34.8575C37.0002 34.2309 37.353 33.3809 37.354 32.4945C37.3531 31.607 37.0002 30.7561 36.3727 30.1287C35.745 29.501 34.8941 29.1481 34.0069 29.1472V29.1472Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6675 29.1472C18.7809 29.1472 17.9305 29.4994 17.3032 30.1265C16.6762 30.7533 16.3237 31.6035 16.3235 32.4903C16.3233 33.3769 16.675 34.2273 17.3018 34.8548C17.9284 35.4821 18.7786 35.8347 19.6652 35.8354C20.5521 35.8358 21.4027 35.4843 22.0302 34.8577C22.6576 34.2314 23.0105 33.3811 23.0114 32.4946C23.0105 31.6075 22.6581 30.7573 22.0313 30.1298C21.4045 29.5024 20.5543 29.149 19.6675 29.1473V29.1472Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.504 7H10V8.92011H13.9904L17.3183 22.8144V22.8142C16.7917 23.4113 16.5167 24.189 16.5506 24.9843C16.5845 25.7796 16.925 26.5309 17.5006 27.0809C18.0763 27.6307 18.8423 27.9365 19.6383 27.9343H37.1423V26.0142H19.6349C19.2175 26.0142 18.832 25.7916 18.6233 25.4302C18.4146 25.0689 18.4146 24.6238 18.6233 24.2623C18.832 23.901 19.2175 23.6782 19.6349 23.6782H36.9532L39.9259 11.6365H16.6139L15.504 7Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_133_3350",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_133_3350"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_133_3350",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.65162fb58af86d7cee5f3bf8128f0ed6.svg";
export { ForwardRef as ReactComponent };